export default __webpack_public_path__ + "static/media/Egemen Kum_Artist.9b7cc9f0.jpeg";